import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import i18n from "@/i18n";
import App from "@/App";
import { armarVigilanteDelSplash } from "@/lib/splashNativo";
import { esRutaEnEspanol } from "@/lib/gemelaDeIdioma";
import { ponerSesionDeAudioAmbiente } from "@/lib/sesionDeAudio";

// #457 (P14) --- EL VIGILANTE DE LA PANTALLA NATIVA DE ARRANQUE.
//
// Con `launchAutoHide: false` la pantalla nativa se queda hasta que alguien pide
// quitarla, y quien lo pide es `BootSplash.js` en cuanto pinta su primer cuadro.
// Si `BootSplash` no llegara a montarse --- una excepcion temprana, lo que sea ---,
// nadie lo pediria y la app quedaria viva DEBAJO de una imagen fija. Esto lo impide:
// a los 4 s se pide igual. Los dos `hide` son idempotentes, y en web esto no programa
// ni un temporizador (el gate vive dentro de `lib/splashNativo.js`).
armarVigilanteDelSplash();

// smoke-alumno (S11): la sesion de audio en "ambient" donde el navegador la tiene (Safari 16.4 y despues, tambien
// la app): cualquier sonido de la pagina se mezcla con la musica del usuario en vez de pausarla. Sin la API, nada.
ponerSesionDeAudioAmbiente();

const rootEl = document.getElementById("root");
const root = ReactDOM.createRoot(rootEl);
const renderApp = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// F4.3b T5 — la landing prerendered no debe parpadear (crimen B).
//
// createRoot().render() DESCARTA el DOM prerendered de #root (no hidrata; es el
// modelo replace-render documentado en scripts/prerender.js). Antes, ese
// reemplazo ocurría cuando i18n aún no tenía los namespaces → LandingPage
// devolvía su LoadingGate y el visitante veía: landing prerendered → SPINNER →
// landing de nuevo.
//
// Fix: SOLO cuando #root trae contenido prerendered (/, /pricing en el build
// web — en rutas ajenas el flash-guard del prerender ya lo vació, y en el build
// de app #root siempre está vacío), se difiere el montaje hasta que i18n cargó
// sus namespaces. El usuario sigue viendo la landing prerendered ESTABLE (HTML
// ya pintado, sin JS que esperar) y React la sustituye por la misma landing ya
// traducida — sin spinner y sin frame en blanco. El resto de rutas monta
// exactamente como siempre.
//
// Red de seguridad: si los locales tardan más de I18N_BOOT_TIMEOUT_MS (CDN
// degradado), se monta de todas formas — mejor el gate de siempre que una
// página que no reacciona.
const I18N_BOOT_TIMEOUT_MS = 2500;

if (rootEl.childElementCount > 0) {
  // post-t7-2a (bloque F): en `/es` y `/es/precios` el espanol se elige ANTES de montar, lo mismo
  // que hara `components/RutasEnEspanol.js` al entrar; asi React cambia el HTML pre-pintado en
  // espanol por la misma pagina ya en espanol. Sin esto, un navegador en ingles veia un hueco en
  // blanco de ~330 ms mientras bajaban los textos (medido en Chrome con 150 ms de latencia).
  const elegirIdioma = () =>
    (esRutaEnEspanol(window.location.pathname) ? i18n.changeLanguage('es') : Promise.resolve());
  const i18nReady = new Promise((resolve) => {
    const loadInitialNamespaces = () =>
      elegirIdioma()
        .then(() => i18n.loadNamespaces(["landing", "common", "pricing"]))
        .then(resolve, resolve);
    if (i18n.isInitialized) loadInitialNamespaces();
    else i18n.on("initialized", loadInitialNamespaces);
  });
  const timeout = new Promise((resolve) => setTimeout(resolve, I18N_BOOT_TIMEOUT_MS));
  Promise.race([i18nReady, timeout]).then(renderApp);
} else {
  renderApp();
}
